import { configureStore } from "@reduxjs/toolkit";
import GuideReducer from "./features/GuideSlice";
import NavBarRuducer from "./features/NavBarSlice";
import GalleryRuducer from "./features/GallerySlice";
import LanguageReducer from "./features/LanguageSlice";
import sharedLayoutReducer from "./features/SharedLayoutSlice";
import responsiveReducer from "./features/ResponsiveSlice";
import utilitiesReducer from './features/UtilitiesSlice'
import homeReducer from './features/HomeSlice'
import tourReducer from './features/TourSlice'

const store = configureStore({
  reducer: {
    guide: GuideReducer,
    nav: NavBarRuducer,
    home: homeReducer,
    tour: tourReducer,
    gallery: GalleryRuducer,
    language: LanguageReducer,
    sharedLayout: sharedLayoutReducer,
    responsive: responsiveReducer,
    utilities: utilitiesReducer,
  },
});

export default store;
